import {
  Context,
  createContext,
  Dispatch,
  ReactNode,
  SetStateAction,
  useContext,
  useEffect,
  useState
} from 'react';
import { useUser } from './useUser';
import { Agency } from '../utils/types';

type AgencyState = {
  agency: Agency | null;
  setAgency: Dispatch<SetStateAction<Agency | null>>;
};

export const AgencyContext: Context<AgencyState> = createContext<AgencyState>({
  agency: null,
  setAgency: () => {}
});

export const AgencyProvider = ({ children }: { children: ReactNode }) => {
  const [agency, setAgency] = useState<Agency | null>(null);
  const { user } = useUser();

  useEffect(() => {
    setAgency(user?.profile.agency || null);
  }, [user]);
  return <AgencyContext.Provider value={{ agency, setAgency }}>{children}</AgencyContext.Provider>;
};

export const useAgency = () => useContext(AgencyContext);
